/**
 * @generated SignedSource<<d34c4e55d155724abcc0b11f9f1c8b86>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObjectArticle_HelpObjectStoreArticle$data = {
  readonly description: string | null | undefined;
  readonly displayLink: string | null | undefined;
  readonly entityKey: string | null | undefined;
  readonly id: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "helpObjectArticle_HelpObjectStoreArticle";
};
export type helpObjectArticle_HelpObjectStoreArticle$key = {
  readonly " $data"?: helpObjectArticle_HelpObjectStoreArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectArticle_HelpObjectStoreArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpObjectArticle_HelpObjectStoreArticle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    },
    {
      "kind": "ScalarField",
      "name": "entityKey"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "HelpObjectStoreArticle"
};

(node as any).hash = "682208df9b841d0148a615a35e6cf93a";

export default node;
